import { FlexBox } from '@ardoq/layout';
import { useFormattingContext } from '../useFormattingContext';
import { FormattingColorPicker } from '../../FormattingColorPicker';
import type { ComponentOrReferenceFormattingRule } from '../types';
import { ColorPickerWrapper } from './atoms';

type FormattingRuleColorPickerOnlyProps = {
  rule: ComponentOrReferenceFormattingRule;
};

export const FormattingRuleColorPickerOnly = ({
  rule,
}: FormattingRuleColorPickerOnlyProps) => {
  const { updateRule } = useFormattingContext();
  const { __id: ruleId, color } = rule;

  return (
    <FlexBox gap="small" flex={2}>
      <ColorPickerWrapper>
        <FormattingColorPicker
          dataTestId="formatting-rule-color-picker"
          value={color}
          onValueChange={color => updateRule(ruleId, { color })}
          isNewConditionalFormatting={true}
        />
      </ColorPickerWrapper>
    </FlexBox>
  );
};
